import {Injectable, Optional} from '@angular/core';
import {asyncScheduler, BehaviorSubject, distinctUntilChanged, Subject, throttleTime} from "rxjs";
import {ActiveInput} from "@app/interfaces/i-keyboard";
import {NgControl} from "@angular/forms";


@Injectable({
  providedIn: 'root'
})
export class KeyboardService {
  private activeInputSource = new BehaviorSubject<ActiveInput | null>(null);

  // Emits the active input while filtering rapid consecutive emissions
  activeInput$ = this.activeInputSource.pipe(
    throttleTime(50, asyncScheduler, { leading: true, trailing: true })
  );

  private currentActiveElement: HTMLElement | null = null;

  constructor(@Optional() private ngControl: NgControl) {
  }

  /**
   * Sets the active input element and updates the cursor position.
   * @param input The input element and control to be set as active.
   */
  SetActiveInput(input: ActiveInput) {
    if (this.currentActiveElement !== input.Element) {
      this.currentActiveElement = input.Element;
      const newInput = {
        ...input,
        cursorPosition: input.Element.selectionStart || 0
      };
      this.activeInputSource.next(newInput);
      input.Element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /**
   * Updates the cursor position of the active input element.
   * @param element The input or textarea element whose cursor position should be updated.
   */
  UpdateCursorPosition(element: HTMLInputElement | HTMLTextAreaElement) {
    const currentValue = this.activeInputSource.getValue();
    currentValue?.Element != element;

    if (currentValue && currentValue?.Element === element) {
      this.activeInputSource.next(currentValue);
    }
  }

  /**
   * Clears the active input unless a new valid active input is provided.
   * @param newActiveElement The new element to check before clearing.
   */
  ClearActiveInput(newActiveElement?: HTMLElement) {
    if (!newActiveElement || newActiveElement !== this.currentActiveElement) {
      this.currentActiveElement = null;
      this.activeInputSource.next(null);
    }
  }
}
